export const nutritionUnits: any = {
  Calories: 'Kcal',
  Protein: 'g',
  'Total Carbohydrate': 'g',
  'Total Fat': 'g',
  Sodium: 'mg',
  'Saturated Fat': 'g',
  'Trans Fat': 'g',
  Cholestrol: 'g',
  'Dietary Fiber': 'g',
  'Total Sugars': 'g',
  'Added Sugars': 'g',
  'Vitamin D': 'mg',
  Calcium: 'mg',
  Iron: 'mg',
  Potassium: 'mg',
};
